import {Component, OnInit} from '@angular/core';
import {ToasterService} from './toaster.service';
import {Toaster} from './toaster.interface';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
})
export class ToastComponent implements OnInit {
  public toasters: Toaster[] = [];
  public duration = 5000;

  constructor(private toasterService: ToasterService) {
  }

  ngOnInit() {
    this.subscribeToaster();
  }

  subscribeToaster() {
    this.toasterService.getToaster().subscribe({
      next: toaster => {
        this.toasters.push(toaster);
        setTimeout(() => {
          this.removeToaster(toaster);
        }, toaster?.duration || this.duration);
      }
    });
  }

  removeToaster(toaster: Toaster): void {
    this.toasters = this.toasters.filter(toasterItem => {
      return toasterItem !== toaster;
    });
  }
}
